<template>
  <Teleport to="body">
    <div v-if="uiStore.activePanel === 'design'" class="deco-panel-modal">
      <div class="deco-panel-backdrop" @click="uiStore.hidePanel()" />
      <div class="deco-panel-inner">
        <div class="deco-panel-header">
          <h3 class="deco-panel-title">デザインを選択</h3>
          <button class="deco-panel-close" @click="uiStore.hidePanel()">✕</button>
        </div>
        <div class="deco-panel-scroll">
          <div class="deco-panel-grid">
            <button
              v-for="(group, i) in groups"
              :key="i"
              class="deco-panel-item deco-design-cell"
              :class="{ 'is-selected': i === selectedIndex }"
              @click="onSelect(i)"
            >
              <img
                v-if="previewUrl(group) && !failed.has(i)"
                :src="previewUrl(group)"
                alt=""
                loading="lazy"
                decoding="async"
                @error="failed.add(i)"
              />
              <span v-else class="deco-design-cell__noimg">画像なし</span>
              <span class="deco-design-cell__name">{{ groupName(group, i) }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useDecoDataStore } from '../../stores/useDecoDataStore'
import { useUiStore } from '../../stores/useUiStore'
import { useApplyDesign } from '../../composables/useApplyDesign'

const decoDataStore = useDecoDataStore()
const uiStore = useUiStore()
const { selectDesign } = useApplyDesign()

const groups = computed(() => decoDataStore.activeDesignGroups)
const selectedIndex = computed(() => decoDataStore.selectedDesignIndex)
// プレビュー画像の読み込みに失敗したグループ index (壊れた画像の代わりに「画像なし」を表示)
const failed = reactive(new Set())

function groupName(group, i) {
  return (group && group.name) ? group.name : `デザイン ${i + 1}`
}

// グループで使われているフレーム画像 (先頭) のサムネイルURL。フレーム未使用なら ''。
function previewUrl(group) {
  const decoId = group?.frames?.[0]?.decoId
  const path = decoDataStore.decoImageUrl(decoId)
  return path ? decoDataStore.storageUrl + 'resize/' + path : ''
}

async function onSelect(i) {
  uiStore.hidePanel()
  if (i === selectedIndex.value) return
  uiStore.setLoading(true)
  try {
    await selectDesign(i)
  } finally {
    uiStore.setLoading(false)
  }
}
</script>